@let banner = bannerStore.banner();
@if (bannerStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation
      [entityType]="EEntityType.banner"
      [relationType]="RelationType.loading"></aw-loading-animation>
  </div>
}
@if (banner && !bannerStore.isLoading()) {
  <div class="relative">
    @if (banner.isTextActive) {
      <div
        class="absolute inset-0 flex flex-col"
        [ngClass]="{
          'justify-start': banner.textAlignmentVertical === 'top',
          'justify-center': banner.textAlignmentVertical === 'center',
          'justify-end': banner.textAlignmentVertical === 'bottom',
          'items-start': banner.textAlignmentHorizontal === 'left',
          'items-center': banner.textAlignmentHorizontal === 'center',
          'items-end': banner.textAlignmentHorizontal === 'right',
        }"
        [ngStyle]="{
          fontFamily: banner.textFont?.name
            ? `'${banner.textFont?.name}'`
            : 'Arial',
          color: banner.textColor,
        }">
        @if (banner.headlineFontSize) {
          <span
            [attr.data-testid]="'bannerHeadline'"
            [attr.aria-label]="
              banner.texts | filterTexts: RelationType.headline | language
            "
            [ngStyle]="{
              'font-size': banner.headlineFontSize | toFontSize,
            }">
            {{ banner.texts | filterTexts: RelationType.headline | language }}
          </span>
        }
        @if (banner.subHeadlineFontSize) {
          <span
            [attr.data-testid]="'bannerSubHeadline'"
            [attr.aria-label]="
              banner.texts | filterTexts: RelationType.subHeadline | language
            "
            [ngStyle]="{
              'font-size': banner.subHeadlineFontSize | toFontSize,
            }">
            {{
              banner.texts | filterTexts: RelationType.subHeadline | language
            }}
          </span>
        }
      </div>
    }
    @if (banner.isImageActive && banner.accessibleImage.imageAlts) {
      <img
        class="mx-auto w-full max-w-[1440px] object-cover"
        [style.max-height.px]="banner.imageHeight"
        [src]="bannerStore.bannerPath()"
        [attr.data-testid]="'bannerImage'"
        [alt]="banner.accessibleImage.imageAlts | language" />
    }
  </div>
}
